/**
 * Parses a contract reference to extract the base contract reference and optional shipment number.
 * 
 * @param ref - The full reference string from the URL (e.g., "CR-CA25479" or "CR-CA25479.01")
 * @returns An object containing the contract reference and shipment number (if present)
 * 
 * @example
 * ```ts
 * parseContractReference('CR-CA25479')
 * // => { contractRef: 'CR-CA25479', shipmentNumber: null }
 * 
 * parseContractReference('CR-CA25479.01')
 * // => { contractRef: 'CR-CA25479', shipmentNumber: '01' }
 * 
 * parseContractReference('CR-BR25128.02')
 * // => { contractRef: 'CR-BR25128', shipmentNumber: '02' }
 * ```
 */
export function parseContractReference(ref: string): {
  contractRef: string;
  shipmentNumber: string | null;
} {
  // Match pattern: CR-XX00000.NN where NN is a two-digit number
  const match = ref.match(/^([A-Z]{2}-[A-Z]{2}\d{4,5})\.(\d{2})$/);

  if (match && match[1] && match[2]) {
    return {
      contractRef: match[1],
      shipmentNumber: match[2],
    };
  }

  // No valid suffix found, return the entire reference as contract ref
  return {
    contractRef: ref,
    shipmentNumber: null,
  };
}
